'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');

module.exports=AngularHelpers.registerModule({
name:'fdc.features.organizationUsers',
dependencies:['ui.router'],
configs:[
require('./organizationUsersConfig')],

components:[
require('./organizationUsersController'),
require('./components/createUserModalController'),
require('./components/deleteUserModalController'),
require('./components/userCreatedModalController'),
require('./components/editOrganizationUserModalController'),
require('./components/editOrganizationUserGroupsModalController')]});
//# sourceMappingURL=index.js.map
